import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '../../contexts/user.context';
import Tabs from '../../components/tabs/tabs.component';
import classes from './styles.module.scss';
import InfrastructureProjectTabs from './tabs/infrastructure-projects-tab.component';
import InvestmentProjectsTab from './tabs/investment-projects-tab.component';
import ImprovementProjectsTab from './tabs/improvement-projects-tab.component';
import { useKato } from '../../contexts/kato.context';
import { KatoType } from '../../types/kato.types';

const baseClass = 'projects-page';
const translationKey = 'projects';

const ProjectsPage = () => {
  const { t } = useTranslation();
  const { kato, link, tab } = useParams<{ kato: string, link: string, tab: string }>();
  const navigate = useNavigate();
  const { isModulePresent, modules } = useUser();
  const [filteredTabs, setFilteredTabs] = useState<{ key: string, label: string }[]>([]);
  const { currentLevel } = useKato();

  const tabs = [
    { key: 'infrastructure-projects', label: t(`${translationKey}.infrastructure-projects.title`) },
    { key: 'SNP_INVESTMENT', label: t(`${translationKey}.SNP_INVESTMENT.title`) },
    { key: 'SNP_IMPROVEMENT', label: t(`${translationKey}.SNP_IMPROVEMENT.title`, { point: t(`of-${currentLevel}`) }) }
  ]

  const onTabChange = (tab: string) => {
    navigate(`/${kato}/${link}/${tab}`);
  }

  useEffect(() => {
    if (!tab) {
      navigate(tabs.filter(tab => isModulePresent(tab.key))[0]?.key, { replace: true });
    }
  }, [tab])

  useEffect(() => {
    const filtered = tabs.filter(tab => isModulePresent(tab.key) && tab.key !== 'SNP_IMPROVEMENT');

    setFilteredTabs(filtered);
  }, [isModulePresent, modules]);

  return (
    tab && <div className={classes[baseClass]}>
      <Tabs tabs={filteredTabs} activeTab={tab} onTabChange={onTabChange} />
      
      <div className={classes[`${baseClass}__content`]}>
        {tab === 'infrastructure-projects' && <InfrastructureProjectTabs />}
        {tab === 'SNP_INVESTMENT' && <InvestmentProjectsTab />}
        {tab === 'SNP_IMPROVEMENT' && <ImprovementProjectsTab />}
      </div>
    </div>
  )
}

export default ProjectsPage